/* unplugin-vue-components disabled *//* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ErrorEnterprise',
  computed: {},
  methods: {}
};